import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { DetailLivraison } from '../../../../utils/types/DetailLivraison';
import { format } from 'date-fns';
import { IClient } from '../../../../utils/types/IClient';

interface PriseDetailsProps {
    prise: DetailLivraison;
    client: IClient | null;
    onClose?: () => void;
}

const PriseDetailsContent: React.FC<PriseDetailsProps> = ({ prise, client }) => {
    return (
        <div className="card">
            <div className="card-body">
                <ul>
                    <li>Numéro bon de livraison : {prise.codeManuel ?? ''}</li>
                    <li>Station : {prise.pointDeVente ?? ''}</li>
                    <li>Client : {client?.cardName ?? ''}</li>
                    <li>Carte : {`${prise.numeroCarte ?? ''} - ${prise.typeCarte ?? ''}`}</li>
                    <li>Produit : {prise.designation ?? ''}</li>
                    <li>Quantité : {prise.quantite ? `${prise.quantite.toFixed(2).replace('.', ',')} L` : ''}</li>
                    <li>Valeur : {`${((prise.prix ?? 0) * (prise.quantite ?? 0)).toFixed(2).replace('.', ',')} $`}</li>
                    <li>Date : {prise.dateEnregistrementLivraison ? `${format(prise.dateEnregistrementLivraison, 'dd/MM/yyyy HH:mm:ss')}` : ''}</li>
                </ul>

                <hr />

                <ul>
                    <li>Code livraison : {prise.codeManuelTerminal ?? ''}</li>
                </ul>
            </div>
        </div>
    );
};

const PriseDetails: React.FC<PriseDetailsProps> = ({ prise, client, onClose }) => {
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => {
        setShowModal(false);
        onClose?.();
    };
    const handleShow = () => setShowModal(true);

    // ---

    return (
        <>
            <button
                onClick={handleShow}
                style={{
                    cursor: 'pointer',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    color: '#0066cc',
                    textDecoration: 'underline',
                }}
            >
                {prise.codeManuel || ''}
            </button>

            <Modal show={showModal} onHide={handleClose} size="lg" scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Détails Livraison #{prise.codeManuel}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <PriseDetailsContent prise={prise} client={client} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default PriseDetails;
